import { Pipe, PipeTransform } from "@angular/core";
import { formatNumberToHuman } from "../number-to-human/number-to-human";

@Pipe({ name: "rateFormat" })
export class RateFormatPipe implements PipeTransform {
  public transform(percent: number) {
    if (typeof percent === "undefined" || percent === null) {
      return "";
    } else if (percent > 0 && percent < 0.01) {
      return "< 0.01";
    } else {
      return formatNumberToHuman(Number(percent.toFixed(2)));
    }
  }
}
